module.exports = __webpack_public_path__ + "channel_2.png";


//////////////////
// WEBPACK FOOTER
// ./src/js/components/pages/newLandingPage/block-slider/assets/channel_2.png
// module id = 1126
// module chunks = 10